// Mutex for MemoryPopover instances — only one popover (Comment or
// Save-to-memory, anywhere in the conversation) can be open at a time.
// Opening any popover automatically closes the previously-open one.
//
// Each MemoryPopover instance gets a unique ID via nextId(). On open, it
// sets activePopoverId to its own ID. The instance watches activePopoverId
// — if it changes to anything else while we're still open, we close.

import { ref } from 'vue';

export const activePopoverId = ref(null);

let _counter = 0;
export function nextPopoverId() {
  return ++_counter;
}
